import type { TextInputProps } from "@mantine/core";
import { TextInput } from "@mantine/core";

export function MonthInput(props: TextInputProps) {
  return <TextInput type="month" {...props} />;
}
